import type { FaireProductEntity } from "../../entity_types/product";

export const p_7fpvnmhthc: FaireProductEntity = {
  token: "p_7fpvnmhthc",
  type: "product",
  name: "Slouchy Open Front Chunky Knit Mid-Long Cardigan",
  brandToken: "b_m4nc6munyv",
  brandName: "Rosa Clothing",
  imageUrl:
    "https://cdn.faire.com/fastly/7646104d39f5d720b037d04e8ccde7fffe6f8b6e1e957e2a82f56904c9d91c71.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2869716e70a572169dfb3dcc316286d2a96d6e554e94015a086f6e9dfd338748.jpeg",
    "https://cdn.faire.com/fastly/d4c44a2692cf8fc1703dc6e6f21b9fa89da02c6a9139863b734e2f27a19d7345.jpeg",
    "https://cdn.faire.com/fastly/195dfecf69f9879e8ad4ac1ccef63ba3e4dfc6cb6f8fea8b2c4a390699dd253b.jpeg",
    "https://cdn.faire.com/fastly/3b74ec555c2336035a7a19a3f085ad2479323752c5f6a3c8aa9f3c4b2ba8bf2b.jpeg",
    "https://cdn.faire.com/fastly/976574114bff16dcb89cee9eaeb62750b5fe7f0efc584bd61e852798c1effa1b.jpeg",
    "https://cdn.faire.com/fastly/14bdfd13d552c666576b5536a576f98e080102e1385227412bf69811ecd442e1.jpeg",
    "https://cdn.faire.com/fastly/b5c11b764c30f4371cea5476310dd815a968e0a69cdc72b45908f6bcc732a631.jpeg",
    "https://cdn.faire.com/fastly/034477b02c141f525e424e5d4b3f310c09218d36b6fb830e4e36ebdbf88c1fd6.jpeg",
    "https://cdn.faire.com/fastly/1c9c33bda08279b167e71907d4ce24138a789e68b97a7aae4ad4570e5642a9aa.jpeg",
  ],
  priceDollars: 32.28,
  description:
    "SLOUCHY OPEN FRONT CHUNKY KNIT MID-LONG CARDIGAN_RCJW06863\n\nSize Chart(Inch)\t\t\n\t Chest\tLength\nS\t 34.65 \t 34.65 \nM\t 36.22 \t 35.04 \nL\t 38.58 \t 35.43 \nXL\t 40.94 \t 35.83 \n\nWomen shackets,crochet cardigan,cable knit sweater,ruffle dress,blouse,puff sleeve western vintage elegant top,denim skirts,fall top,fall dress,blazer，Knit cardigan,Midi dress,Laple Shirts,Tank Top,Knit Top,High waist pants,Button down Jacket,Skirt,Ruffle blouse,Sweatshirt,hoodie,midi dress,knit sweater,2 piece set,denim jacket,plaid shirt,zip up jacket,wide leg pant,fur coat，tweed jacket,2026 Women Apparel",
  tags: [],
  msrpDollars: 64.55,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:48.854Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
